import { render, staticRenderFns } from "./call_shutoff.vue?vue&type=template&id=054916c8&"
import script from "./call_shutoff.vue?vue&type=script&lang=js&"
export * from "./call_shutoff.vue?vue&type=script&lang=js&"
import style0 from "./call_shutoff.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports